/**
 * A entrada nos autos para peticionar (docs/PLANO_BANCADA.md, Bloco 4): a tela de
 * peticionar saiu, e quem pedia "Peticionar", "Usar modelo" ou "Continuar o
 * rascunho" chega aos autos com o editor à vista e a barra do protocolo pronta.
 *
 * - `editor=1`: a área central abre no editor;
 * - `rascunho=<id>`: a barra abre ESTA petição (na instância dela);
 * - `modelo=<id>`: o modelo vai para o editor (o texto de antes fica em Versões).
 *
 * Os autos consomem os três na entrada: voltar a esta URL não reaplica o modelo.
 */
export const PARAM_EDITOR = 'editor';
export const PARAM_RASCUNHO = 'rascunho';
export const PARAM_MODELO = 'modelo';

/**
 * Só ids de verdade (UUID): os dois vão para caminhos da API (`/peticoes/{id}`,
 * `/modelos-peticao/{id}/aplicar`), e um `rascunho=../../outra/rota` num link faria a
 * tela chamar outro endpoint com a sessão da pessoa (path traversal no cliente).
 */
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export function idDaEntrada(valor: string | null | undefined): string | null {
  return valor && UUID.test(valor) ? valor : null;
}

interface EntradaDoProtocolo {
  /** Id da petição a reabrir na barra. */
  rascunho?: string | null;
  /** Id do modelo a aplicar no editor. */
  modelo?: string | null;
}

/** A busca (`?editor=1&…`) dos autos para peticionar. */
export function buscaDoProtocolo({ rascunho, modelo }: EntradaDoProtocolo = {}): string {
  const params = new URLSearchParams({ [PARAM_EDITOR]: '1' });
  const r = idDaEntrada(rascunho);
  const m = idDaEntrada(modelo);
  if (r) params.set(PARAM_RASCUNHO, r);
  if (m) params.set(PARAM_MODELO, m);
  return `?${params.toString()}`;
}

/** Os autos do processo, prontos para peticionar. */
export function urlDoProtocolo(numero: string, entrada: EntradaDoProtocolo = {}): string {
  return `/app/processos/${encodeURIComponent(numero)}/autos${buscaDoProtocolo(entrada)}`;
}
